export default "__VITE_ASSET__AiLd5gOMPIKCr0hGhupNmg__"